export const packageVersion = process.env._PACKAGE_VERSION_ as string;
